import SearchForm from './component'

export default SearchForm